const conditionClassModifier = (condition) => condition?.toLowerCase().replace(/_/g, '-');

export default conditionClassModifier;
